/** Google 画像検索 URL */
export function googleImageSearchUrl(word: string): string {
  return `https://www.google.com/search?tbm=isch&q=${encodeURIComponent(word)}`;
}

/** Weblio 英和・和英 URL */
export function weblioUrl(word: string): string {
  return `https://ejje.weblio.jp/content/${encodeURIComponent(word.trim().toLowerCase())}`;
}
